/**
 * Portal-Target-Helper fuer alle Modal-Overlays im Portal.
 *
 * Bei HTML-Fullscreen (element.requestFullscreen()) rendert der Browser
 * NUR den Inhalt des Fullscreen-Elements. Modals, die per createPortal in
 * document.body haengen, liegen ausserhalb dieses Fullscreen-Elements und
 * sind entweder unsichtbar oder liegen visuell „hinter" dem Fullscreen-
 * Fenster (z.B. Plantafel-Vollbild auf zweitem Monitor + „Neue Aufgabe"-
 * Dialog, Cluster 1.3 aus Probst-Besprechung 2026-06-25).
 *
 * Fix: bei aktivem Fullscreen den Portal-Target dynamisch auf das
 * Fullscreen-Element setzen. Ohne Fullscreen weiter document.body — das
 * ist der Standard-Fall.
 *
 * Wird beim Modal-Mount ausgewertet. Fullscreen-Wechsel WAEHREND ein Modal
 * schon offen ist wird nicht abgefangen (Randfall).
 */
export function getModalPortalTarget(): HTMLElement {
  return (document.fullscreenElement as HTMLElement | null) ?? document.body;
}
